import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import axios, { ResponseType } from "axios";
import IApiClient from "./IApiClient";

const api = axios.create({
  baseURL: "https://apicms.neci.vn",
  timeout: 3600000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("warehouse-cms-token");
    const request = config;

    if (token) {
      request.headers = {
        Authorization: `Bearer ${token}`,
      } as any;
      request.headers!["ngrok-skip-browser-warning"] = "69420"; //For NGROK
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    // Return JSON data
    if (response.data) {
      return response.data;
    }
    return response;
  },
  (error) => {
    const err = error.response || error;
    // if (error?.response?.status === 403) {
    //   if (!!localStorage.getItem("warehouse-cms-token")) {
    //     localStorage.clear();
    //     window.location.href = "/sign-in"; //relative to domain
    //   }
    // }
    return Promise.reject(err.data);
  }
);

class AxiosClient implements IApiClient {
  async post<T extends Object>(
    path: string,
    data: Map<string, any> | any,
    config?: Map<string, any> | any
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.post(path, data, config);
    return response;
  }

  async get<T extends Object>(
    path: string,
    data?: Map<string, any> | any,
    config?: Map<string, any> | any,
    responseType?: ResponseType
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.get(path, {
      params: data,
      headers: config,
      responseType: responseType,
    });
    return response;
  }

  async delete<T extends Object>(
    path: string,
    data: Map<string, any> | any
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.delete(path, {
      params: data,
    });
    return response;
  }

  async put<T extends Object>(
    path: string,
    data: Map<string, any> | any,
    config?: Map<string, any> | any
  ): Promise<BaseApiResponseModel<T>> {
    let response = await api.put(path, data, config);
    return response;
  }
}

export default new AxiosClient();
